<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { itemCategoryList } from '../../service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: '',
    valName: '',
    category: {
      type: Number,
      default: 2,
    },
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else {
        this.requestDefaultItemCategory()
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.val > 0) {
      this.requestDefaultItemCategory()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    async requestDefaultItemCategory() {
      let res = await itemCategoryList({
        item_category_id: this.val,
        is_select_option: true,
      })
      this.lists = res.data.list.map((item) => {
        if (item.whole_name) {
          item.name = item.whole_name.replace(/,/g, ' - ')
        }
        return item
      })

      let that = this
      this.$nextTick(() => {
        that.selected = this.val
      })
    },
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          query: query,
          category: this.category,
          page: 0,
          size: 20,
          is_select_option: true,
        }
        let res = await itemCategoryList(data)
        this.loading = false
        this.lists = res.data.list.map((item) => {
          if (item.whole_name) {
            item.name = item.whole_name.replace(/,/g, ' - ')
          }
          return item
        })
      } else {
        this.lists = []
      }
    },
  },
}
</script>